import React, { useState, useRef, useEffect } from 'react';
import { Animated, Button, ScrollView, View, FlatList } from 'react-native';
import firebase from '../firebase/Config';
import '../public/app.module.css'

var PROJECTS = [];
var numColumns = Math.ceil(PROJECTS.length / 2);

function getName(name) {
    if (name == "") {
        return "Untitled"
    } else {
        return name;
    }
}

const Project = ({ name, albumArtRef, onPress }) => (
    <div onClick={onPress} className="projectCell">
        <img
            className="albumArtImg"
            src={(albumArtRef == null) ? "https://images.unsplash.com/photo-1557683311-eac922347aa1?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8M3x8Ymx1ZSUyMGFuZCUyMHB1cnBsZSUyMGdyYWRpZW50fGVufDB8fDB8fA%3D%3D&w=1000&q=80" : albumArtRef}
        />
        <span className="nameText">{name}</span>
    </div>
);

const ChooseProjectScreen = props => {

    const [refreshData, setRefreshData] = useState(false);

    firebase.database().ref("artists").child(props.route.params.item.id).child("projects").once("value").then(snapshot => {
        PROJECTS = [];
        const projects = snapshot.val();
        for (const projectId in projects) {
            const albumArtId = projects[projectId].metadata["album art"];
            const data = {
                id: projectId,
                artistId: props.route.params.item.id,
                artistName: props.route.params.item.name,
                name: getName(projects[projectId].metadata.name)
            };
            
            if (albumArtId != null) {
                data["albumArtRef"] = projects[projectId].art[albumArtId].metadata["remote url"];
            }

            PROJECTS.push(data);
        }

        if (PROJECTS.length > 5) {
            numColumns = Math.ceil(PROJECTS.length / 2);
        } else {
            numColumns = Math.ceil(PROJECTS.length / 2) + 1;
        }

        PROJECTS.sort((a, b) => (a.name > b.name) ? 1 : -1); // Sort alphabetically
        setRefreshData(true);
    });

    const renderProject = ({ item }) => (
        <Project name={item.name} albumArtRef={item.albumArtRef} onPress={() => props.navigation.navigate('DragDropScreen', { item })} />
    );

    const fadeAnim = useRef(new Animated.Value(0)).current  // Initial value for opacity: 0

    useEffect(() => {
        Animated.timing(
            fadeAnim,
            {
                toValue: 1,
                duration: 950,
            }
        ).start();
    }, [fadeAnim])

    function handleBackButtonClick() {
        PROJECTS = [];
        props.navigation.navigate('ChooseArtistScreen');
    }

    return (
        <div className="main">
            <div className="header">
                <div className="row">
                    <div className="buttonView">
                        <Button
                            onPress={handleBackButtonClick}
                            title="Back"
                        />
                    </div>
                    <span className="headerText">Select a Project</span>
                </div>
            </div>
            <div className="container">
                <Animated.View style={{ opacity: fadeAnim }}>
                    <ScrollView
                        horizontal
                        showsVerticalScrollIndicator={false}
                        showsHorizontalScrollIndicator={false}
                        contentContainerStyle={{ paddingVertical: 20 }}>
                        <FlatList
                            style={{flexGrow: 0}}
                            scrollEnabled={false}
                            numColumns={numColumns}
                            showsVerticalScrollIndicator={false}
                            showsHorizontalScrollIndicator={false}
                            extraData={refreshData}
                            data={PROJECTS}
                            renderItem={renderProject}
                            key={numColumns}
                            keyExtractor={item => item.id}
                        />
                    </ScrollView>
                </Animated.View>
            </div>
        </div>
    );
}

export default ChooseProjectScreen;